<script lang="ts">
  import { resolveContent } from "$lib/content/registry";
  import PageContainer from '$lib/components/PageContainer.svelte';
  import type { PageData } from './$types';

  let { data }: { data: PageData } = $props();

  // Use the proper dynamic content registry
  const Component = resolveContent('terms', data.brand);
</script>

<svelte:head>
  <title>Terms of Service - {data.config.displayName}</title>
  <meta name="description" content="Terms of service for {data.config.displayName} platform and services." />
  <meta property="og:title" content="Terms of Service - {data.config.displayName}" />
  <meta property="og:type" content="website" />
</svelte:head>

<PageContainer config={data.config}>
  {#if Component}
    <svelte:component this={Component} data={data} />
  {:else}
    <div class="error-container">
      <h1>Content Not Found</h1>
      <p>The terms of service content could not be loaded.</p>
    </div>
  {/if}
</PageContainer>
